import * as components from './components';

export default [
  {
    path: '/masters/users',
    component: components.UserList,
    name: 'usersList',
    meta: { admin: true }
  }
];


// WEBPACK FOOTER //
// ./ClientApp/app/masters/users/routes.js